<template>
    <div class="content_div" style="padding:20px">
        <el-card v-if="loading" style="text-align:center;padding:60px">
            <i class="el-icon-loading" style="font-size:40px;color:#409EFF"/>
            <p style="margin-top:16px;color:#999">加载中...</p>
        </el-card>
        <div v-else-if="previewData">
            <el-card>
                <div style="text-align:center;margin-bottom:20px">
                    <h2>{{ previewData.title }}</h2>
                    <p style="color:#999;font-size:13px">级别：{{ previewData.levelName }}</p>
                </div>
                <el-tabs v-model="activeModule">
                    <el-tab-pane label="范文挖空" name="gapFill">
                        <el-tabs v-model="activeGapFillTab" type="border-card">
                            <el-tab-pane label="初级" name="low">
                                <template v-if="gapFillList('low').length > 0">
                                    <div v-for="item in gapFillList('low')" :key="item.sentenceNo" style="margin-bottom:14px">
                                        <div style="display:flex;align-items:baseline;gap:8px">
                                            <span style="color:#909399;font-size:12px;min-width:30px">{{ item.sentenceNo }}.</span>
                                            <span style="white-space:pre-wrap;line-height:1.8">{{ item.gappedSentence }}</span>
                                        </div>
                                        <div style="margin-left:38px;margin-top:4px">
                                            <el-tag v-for="(ans,i) in item.answers" :key="i" size="small" type="success" style="margin-right:6px;margin-bottom:4px">{{ ans }}</el-tag>
                                        </div>
                                    </div>
                                </template>
                                <el-empty v-else description="暂无数据" :image-size="50"/>
                            </el-tab-pane>
                            <el-tab-pane label="中级" name="medium">
                                <template v-if="gapFillList('medium').length > 0">
                                    <div v-for="item in gapFillList('medium')" :key="item.sentenceNo" style="margin-bottom:14px">
                                        <div style="display:flex;align-items:baseline;gap:8px">
                                            <span style="color:#909399;font-size:12px;min-width:30px">{{ item.sentenceNo }}.</span>
                                            <span style="white-space:pre-wrap;line-height:1.8">{{ item.gappedSentence }}</span>
                                        </div>
                                        <div style="margin-left:38px;margin-top:4px">
                                            <el-tag v-for="(ans,i) in item.answers" :key="i" size="small" type="warning" style="margin-right:6px;margin-bottom:4px">{{ ans }}</el-tag>
                                        </div>
                                    </div>
                                </template>
                                <el-empty v-else description="暂无数据" :image-size="50"/>
                            </el-tab-pane>
                            <el-tab-pane label="高级" name="high">
                                <template v-if="gapFillList('high').length > 0">
                                    <div v-for="item in gapFillList('high')" :key="item.sentenceNo" style="margin-bottom:14px">
                                        <div style="display:flex;align-items:baseline;gap:8px">
                                            <span style="color:#909399;font-size:12px;min-width:30px">{{ item.sentenceNo }}.</span>
                                            <span style="white-space:pre-wrap;line-height:1.8">{{ item.gappedSentence }}</span>
                                        </div>
                                        <div style="margin-left:38px;margin-top:4px">
                                            <el-tag v-for="(ans,i) in item.answers" :key="i" size="small" type="danger" style="margin-right:6px;margin-bottom:4px">{{ ans }}</el-tag>
                                        </div>
                                    </div>
                                </template>
                                <el-empty v-else description="暂无数据" :image-size="50"/>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane label="固定搭配" name="collocations">
                        <el-table :data="previewData.collocationExercises" border size="small" v-if="previewData.collocationExercises && previewData.collocationExercises.length > 0">
                            <el-table-column type="index" label="#" width="40"/>
                            <el-table-column prop="english" label="英文" min-width="200"/>
                            <el-table-column prop="chinese" label="中文" min-width="200"/>
                        </el-table>
                        <el-empty v-else description="暂无数据" :image-size="50"/>
                    </el-tab-pane>
                    <el-tab-pane label="好词" name="words">
                        <el-table :data="previewData.goodWordExercises" border size="small" v-if="previewData.goodWordExercises && previewData.goodWordExercises.length > 0">
                            <el-table-column type="index" label="#" width="40"/>
                            <el-table-column prop="english" label="英文" min-width="160"/>
                            <el-table-column prop="chinese" label="中文" min-width="160"/>
                            <el-table-column prop="partOfSpeech" label="词性" width="80"/>
                        </el-table>
                        <el-empty v-else description="暂无数据" :image-size="50"/>
                    </el-tab-pane>
                    <el-tab-pane label="好句" name="sentences">
                        <el-table :data="previewData.goodSentenceExercises" border size="small" v-if="previewData.goodSentenceExercises && previewData.goodSentenceExercises.length > 0">
                            <el-table-column type="index" label="#" width="40"/>
                            <el-table-column prop="english" label="英文" min-width="300"/>
                            <el-table-column prop="chinese" label="中文" min-width="300"/>
                        </el-table>
                        <el-empty v-else description="暂无数据" :image-size="50"/>
                    </el-tab-pane>
                    <el-tab-pane label="逐句翻译" name="translation">
                        <el-table :data="previewData.translationExercises" border size="small">
                            <el-table-column type="index" label="序号" width="60"/>
                            <el-table-column prop="chinese" label="汉语" min-width="250"/>
                            <el-table-column prop="englishReference" label="参考英语" min-width="250"/>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="汉语草稿" name="chineseDraft">
                        <h4 style="margin-bottom:8px">参考范文</h4>
                        <div style="white-space:pre-wrap;line-height:1.8;background:#f5f7fa;padding:15px;border-radius:4px">{{ previewData.modelEssay }}</div>
                        <el-divider/>
                        <h4 style="margin-bottom:8px">全文翻译</h4>
                        <div style="white-space:pre-wrap;line-height:1.8;background:#f0f9eb;padding:15px;border-radius:4px">{{ previewData.fullTranslation }}</div>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
            <div style="text-align:center;margin-top:16px">
                <el-button type="primary" icon="el-icon-download" @click="handleDownload">下载Word</el-button>
            </div>
        </div>
        <el-card v-else style="text-align:center;padding:60px">
            <el-empty description="作文不存在或已删除"/>
        </el-card>
    </div>
</template>

<script>
import { previewEssay, downloadEssay } from '@/api/education/essay'

export default {
    name: 'EssayPreview',
    data() {
        return { previewData: null, loading: true, activeModule: 'gapFill', activeGapFillTab: 'low', instanceId: null }
    },
    created() {
        this.instanceId = this.$route.params.id
        if (this.instanceId) {
            previewEssay(this.instanceId).then(r => { this.previewData = r; this.activeGapFillTab = r.level || 'low'; this.loading = false }).catch(() => { this.loading = false })
        } else {
            this.loading = false
        }
    },
    methods: {
        gapFillList(level) {
            return this.previewData?.gapFillLevels?.[level] || []
        },
        async handleDownload() {
            try {
                const r = await downloadEssay(this.instanceId)
                if (r) window.open(r, '_blank')
                else this.$message.warning('下载链接为空')
            } catch (e) { this.$message.error('下载失败') }
        }
    }
}
</script>
